import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';
import { DayPicker } from '@s/DayPicker/DayPicker'

export const DateQuestion = ({
  onFocus: onFocusProp,
  onBlur: onBlurProp,
  onAnswerUpdate,
  textQuestionValue,
  ...rest
}) => {
  const locale = useSelector(state => state.intl.locale);

  const dayPickerRef = useRef(null);
  const [isPickerVisible, setIsPickerVisible] = useState(false);

  const inputWrapClassName = classNames('input', 'input--inset', 'input--date');

  const selectedDay = textQuestionValue ? new Date(textQuestionValue) : undefined;

  const formatedDateString = textQuestionValue ? new Date(textQuestionValue).toLocaleDateString(locale) : '';

  const onBlur = () => {
    // need delay, since onBlur triggers question validatio
    // so it need a small gap before answer update in the store
    setTimeout(() => {
      onBlurProp?.();
    }, 100);
  };

  const showDayPicker = () => {
    setIsPickerVisible(true);
    document.addEventListener('mousedown', onClickOutside);
  };

  const hideDayPicker = () => {
    setIsPickerVisible(false);
    onBlur();
    document.removeEventListener('mousedown', onClickOutside);
  };

  const onFocus = e => {
    onFocusProp?.(e);
    showDayPicker();
  };

  const onDaySelect = e => {
    const value = `${moment(e).format('MM/DD/YYYY')}`;
    onAnswerUpdate(value);
    hideDayPicker();
  };

  const onClickOutside = e => {
    if (!dayPickerRef.current) return;

    if (!dayPickerRef.current.contains(e.target)) {
      hideDayPicker();
    }
  };

  useEffect(() => {
    return () => {
      document.removeEventListener('click', onClickOutside);
    };
  }, []);

  return (
    <div className={inputWrapClassName}>
      <input
        className="input__control"
        type="text"
        name="date_question"
        readOnly
        placeholder="Your answer here"
        onFocus={onFocus}
        value={formatedDateString}
        {...rest}
      />
      {isPickerVisible && (
        <div ref={dayPickerRef} className="input--date-picker-wrapper">
          <div className="ReactDayPicker ReactDayPicker--date-question">
            <DayPicker
              onSelect={onDaySelect}
              selected={selectedDay}
            />
          </div>
        </div>
      )}
    </div>
  );
};
